import { loadCart } from "../../store/actions/cartActions";
import { ApiClient } from "../../utils/api-client";

export const getCartItems = async () => {
  try {
    const response = await ApiClient.get('/cart', {});
    return response.data.cartEntries;
  } catch (e) {
    console.log("cart error", e);
    return await {}
  }
}

export const removeCartItem = async (item, dispatch) => {
  await ApiClient.delete('/cart', {
    data: item
  });

  getCartItems().then(cartItems => {
    dispatch(loadCart(cartItems));
  });

}

export const addCartItem = async (item, dispatch) => {
  const cartItem = {
      companyId: item.debtor.companyId
  }
  
  await ApiClient.post('/cart', cartItem, {});

  getCartItems().then(cartItems => {
    dispatch(loadCart(cartItems));
  });

}

export const getUrlPayment = async () => {
  try {
    const response = await ApiClient.get('/payment/url', {
      params: {
        billId: 'bf371070-a803-42ed-9810-df875937c7fe'
      }
    });

    return response.data;
  } catch (e) {
    return await { paymentUrl: '' }
  }
}